import { render, staticRenderFns } from "./loading-cms.vue?vue&type=template&id=2f98efdd&scoped=true"
import script from "./loading-cms.vue?vue&type=script&lang=js"
export * from "./loading-cms.vue?vue&type=script&lang=js"
import style0 from "./loading-cms.vue?vue&type=style&index=0&id=2f98efdd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f98efdd",
  null
  
)

export default component.exports